import type { ComparisonRow, SimpleCard } from '../types/content';

export const quickBenefits: SimpleCard[] = [
  { title: '5 TOMOS', copy: 'Sistema completo' },
  { title: '250+ PÁGINAS', copy: 'Contenido práctico' },
  { title: '5 BONOS', copy: 'Herramientas de ejecución' },
  { title: 'ACCESO INMEDIATO', copy: 'Empieza hoy' }
];

// What happens before ever stepping on court — the real "problem" today.
export const problemPoints: string[] = [
  'Pensar qué ejercicios hacer.',
  'Adaptarlos al nivel de cada grupo.',
  'Evitar repetir siempre las mismas clases.',
  'Crear progresiones con sentido.',
  'Organizar diferentes niveles.',
  'Preparar la siguiente sesión fuera de tu horario de pista.'
];

export const insideBenefits: string[] = [
  'Ejercicios explicados',
  'Progresiones organizadas',
  'Sesiones estructuradas',
  'Aplicación directa en pista'
];

export const insideScreenshots: string[] = [
  'Ficha 05 — Salida de Pared de Fondo',
  'Semáforo de Errores — Base de la Bandeja',
  'Ficha 14 — Regla de los 3 Golpes',
  'La Volea de Definición',
  'Ficha 12 — Remate con Decisión',
  'Ficha 06 — Pared Lateral y Doble Pared',
  'Las 8 Zonas Críticas del Pádel'
];

export const sinSistema: string[] = [
  'Ejercicios guardados por todas partes',
  'Preparación a última hora',
  'Clases que terminan pareciéndose demasiado',
  'Dudas sobre qué progresión seguir',
  'Depender constantemente de tu memoria'
];

export const conSistema: string[] = [
  'Recursos organizados',
  'Progresiones con criterio',
  'Material listo para consultar',
  'Clases más estructuradas',
  'Más tiempo para centrarte en tus alumnos'
];

export interface CareerStage {
  title: string;
  copy: string;
}

export const careerStages: CareerStage[] = [
  {
    title: 'Si estás empezando',
    copy: 'Consigue estructura y recursos para preparar tus clases con mayor seguridad.'
  },
  {
    title: 'Si ya tienes experiencia',
    copy: 'Amplía tu repertorio, organiza mejor tus conocimientos y evita caer siempre en las mismas sesiones.'
  },
  {
    title: 'Si diriges una escuela o equipo de monitores',
    copy: 'Utiliza una base metodológica más organizada para facilitar la planificación y el trabajo de tu equipo.'
  }
];

export const valueConcepts: string[] = ['Mejor organización', 'Mayor valor percibido', 'Más fidelización'];

export const comparisonRows: ComparisonRow[] = [
  { feature: '5 Tomos', base: true, kit: true },
  { feature: '250+ páginas', base: true, kit: true },
  { feature: '5 Bonos', base: true, kit: true },
  { feature: 'Fichas de Pista', base: true, kit: true },
  { feature: 'Radar del Alumno', base: true, kit: true },
  { feature: '50 Correcciones', base: true, kit: true },
  { feature: 'Planificador 30 Días', base: true, kit: true },
  { feature: 'Vuelta a Pista', base: true, kit: true },
  { feature: 'Mapa de Pista', base: false, kit: true },
  { feature: '50 Esquemas Visuales', base: false, kit: true },
  { feature: 'Programador 12 Meses', base: false, kit: true }
];
